"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Wrench, HardHat, Settings, PhoneCall } from "lucide-react";
export default function OurServicesOverview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const services = [{
    id: 1,
    icon: Wrench,
    title: "Design",
    description: "Custom HVAC system design tailored to your space and energy goals.",
    link: "/ServicesPage"
  }, {
    id: 2,
    icon: HardHat,
    title: "Installation",
    description: "Expert installation of residential and commercial heating and cooling systems.",
    link: "/ServicesPage"
  }, {
    id: 3,
    icon: Settings,
    title: "Maintenance",
    description: "Scheduled maintenance to keep your HVAC running efficiently year-round.",
    link: "/ServicesPage"
  }, {
    id: 4,
    icon: PhoneCall,
    title: "Emergency Repair",
    description: "Fast, reliable emergency service when your system needs immediate attention.",
    link: "/ContactPage"
  }];
  return <section ref={sectionRef} className="bg-light-background py-16 px-6 md:px-12 lg:px-20">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground-light md:text-5xl">
            Our Services Overview
          </h2>
          <p className="mt-4 text-lg text-foreground-light/70">
            Comprehensive HVAC solutions for Pittsburgh homes and businesses
          </p>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={service.id} data-index={i} className={`group relative flex flex-col border border-border bg-muted-light-background px-6 py-8 shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-[3px] hover:shadow-strong ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${i * 80}ms` : "0ms"
          }}>
                <CardHeader className="p-0">
                  <div className="mb-4 flex size-14 items-center justify-center rounded-lg bg-primary text-foreground-primary">
                    <Icon className="size-7" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-foreground-light">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-1 p-0 pt-4">
                  <p className="text-sm leading-relaxed text-foreground-light/80">
                    {service.description}
                  </p>
                </CardContent>
                <div className="mt-6">
                  <Link to={service.link} className="group/link inline-flex items-center text-sm font-semibold text-primary transition-colors duration-[var(--duration-medium)] hover:text-primary-hover">
                    Learn More
                    <span className="ml-1 inline-block w-0 overflow-hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover/link:w-4">
                      →
                    </span>
                  </Link>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}